import React from 'react';
import {
  Axe, Biohazard, BowArrow, Brain, Droplet, Eye, FlaskConical, Flame, Ghost, Hammer, HandFist, HeartPulse, Megaphone,
  Shield, Skull, Snowflake, Sparkle, Sparkles, Sun, Sword, Swords, WandSparkles, Waves, Wind, Zap,
} from 'lucide-react';

// Line icons for everything the action panel can hold (attacks, spells, features), in the style of the class feature
// tiles: one lucide glyph tinted by the tile's accent. The first matching rule wins: what the action does (healing,
// damage type), then its weapon, then its spell school.
const RULES = [
  [/\b(heal|healing|cure|wounds|restor|aid|lesser restoration|regenerat)/, HeartPulse],
  [/fire|flame|burn|scorch/, Flame],
  [/cold|ice|frost|freez/, Snowflake],
  [/lightning|storm|shock/, Zap],
  [/thunder/, Waves],
  [/radiant|holy|divine|sacred|smite|guiding/, Sun],
  [/necrotic|shadow|death|chill touch|blight/, Skull],
  [/poison|toxin|venom/, Biohazard],
  [/acid/, Droplet],
  [/psychic|mind|mockery/, Brain],
  [/force|arcane|magic missile|eldritch/, Sparkle],
  [/command|suggestion|dominate/, Megaphone],
  [/breath|dragon|gust|wind/, Wind],
  [/bow|crossbow|arrow|sling|dart|ranged/, BowArrow],
  [/axe/, Axe],
  [/hammer|mace|maul|club|flail|morningstar|quarterstaff|staff/, Hammer],
  [/dagger|knife|sword|rapier|scimitar|blade|sickle/, Sword],
];
const SCHOOLS = {
  abjuration: Shield, conjuration: Sparkles, divination: Eye, enchantment: Sparkles,
  evocation: Flame, illusion: Ghost, necromancy: Skull, transmutation: FlaskConical,
};

/** The lucide icon component for an action-panel entry. */
export const actionIconComponent = (attack = {}) => {
  const school = String(attack.school || '').trim().toLowerCase();
  const haystack = `${attack.name || ''} ${attack.damageText || ''} ${attack.damageType || ''} ${attack.weaponType || ''}`.toLowerCase();
  if (attack.kind === 'unarmed' || /unarmed/.test(haystack)) return HandFist;
  const rule = RULES.find(([pattern]) => pattern.test(haystack));
  if (rule) return rule[1];
  if (SCHOOLS[school]) return SCHOOLS[school];
  if (attack.kind === 'spell' || attack.kind === 'cantrip') return WandSparkles;
  if (attack.kind === 'feature') return Sparkles;
  return Swords;
};

/** The icon element for an action-panel entry (tiles, cards and the inspector size it with CSS). */
export const actionIcon = (attack, size = 20) => {
  const Icon = actionIconComponent(attack);
  return <Icon size={size} />;
};
